import { Events } from 'global/constants';

let instance;

class AddressStore {
	constructor(initalAddressList) {
		this.oldAddressList = [];
		this.newAddressList = [...initalAddressList];
		window.od.events.subscribe(
			Events.ADDRESS_STORE_UPDATE,
			this.update.bind(this),
		);
	}

	subscribe(callback) {
		window.od.events.subscribe(Events.ADDRESS_STORE_CHANGED, callback);
		window.od.events.subscribe(
			Events.ADDRESS_STORE_SUBSCRIBED,
			this.storeCallback.bind(this, callback),
		);

		this.publish(Events.ADDRESS_STORE_SUBSCRIBED);
	}

	storeCallback(subscriberCallback, event) {
		window.od.events.unsubscribe(
			Events.ADDRESS_STORE_SUBSCRIBED,
			this.storeCallback,
		);
		subscriberCallback(event);
	}

	unsubscribe(callback) {
		window.od.events.unsubscribe(Events.ADDRESS_STORE_CHANGED, callback);
	}

	publish(eventName) {
		window.od.events.publish(eventName, {
			oldValue: this.oldAddressList,
			newValue: this.newAddressList,
		});
	}

	update(eventObj) {
		this.oldAddressList.push([...this.newAddressList]);
		this.newAddressList = [...eventObj.payload];
		this.publish(Events.ADDRESS_STORE_CHANGED);
	}
}

export default function (initialList = []) {
	if (!instance) {
		instance = new AddressStore(initialList);
	}

	return instance;
}
